import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";

const SearchModalCardError = () => {
  return <div className="_hasErrors">{translate(STRINGS.AN_ERROR_HAS_OCCURED)}</div>;
};

export default SearchModalCardError;
